var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", [_vm._v("Дата:")]),
      _vm._v(" "),
      _c("el-date-picker", {
        attrs: {
          "value-format": "yyyy-MM-dd",
          format: "dd.MM.yyyy",
          "picker-options": _vm.datePickerOptions,
          placeholder: "Выбрать день"
        },
        model: {
          value: _vm.choosenDay,
          callback: function($$v) {
            _vm.choosenDay = $$v
          },
          expression: "choosenDay"
        }
      }),
      _vm._v(" "),
      _c("b-table", {
        staticClass: "mt-3",
        attrs: {
          items: _vm.stats,
          fields: _vm.columns.concat(_vm.columnsInner)
        },
        scopedSlots: _vm._u([
          {
            key: "HEAD[idWorker]",
            fn: function(data) {
              return [_vm._v("\n        " + _vm._s(data.label) + "\n      ")]
            }
          },
          {
            key: "HEAD[total]",
            fn: function(data) {
              return [
                _vm._v(
                  "\n        " +
                    _vm._s("Оборот (итого): " + data.field.maxTurnover)
                ),
                _c("hr"),
                _vm._v("\n        " + _vm._s(data.label) + "\n      ")
              ]
            }
          },
          {
            key: "HEAD[sumProbablyEarning]",
            fn: function(data) {
              return [_vm._v("\n        " + _vm._s(data.label) + "\n      ")]
            }
          },
          {
            key: "HEAD[]",
            fn: function(data) {
              return [
                _vm._v("\n        " + _vm._s(data.label)),
                _c("hr"),
                _vm._v(
                  "\n        " + _vm._s("Оборот: " + data.field.maxTurnover)
                ),
                _c("hr"),
                _vm._v(
                  "\n        " +
                    _vm._s(parseInt(data.field.maxPercent) + "%") +
                    "\n      "
                )
              ]
            }
          },
          {
            key: "[]",
            fn: function(data) {
              return [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      data.value instanceof Object
                        ? data.value.reward
                          ? parseFloat(data.value.reward).toFixed(0)
                          : "-"
                        : data.value
                    ) +
                    "\n      "
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6acdc852", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6acdc852","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StatsWorkshopScreen.vue
// module id = null
// module chunks = 